import React, { useEffect, useRef, useState, FC } from 'react'
import { useAppDispatch, useAppSelector } from '../../utils/agent.store'
import FormRenderer from '../FormRenderer'
import {
  addToaster,
  attachCaseById,
  checkPaySignFlowAPI,
  completeTaskByTaskIdApi,
  createTaskApi,
  DataTypeStore,
  discardWebIntakeApi,
  ErrorResponse,
  fetchDuplicateRecordsAPI,
  fetchTypeStatusForCommunications,
  getCaseDedupeStageData,
  getEntityDataByEntityFilter,
  getEntityDataByEntityNameApiForFilter,
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
  getLayoutByEntityIdAndTypeApi,
  getLayoutByIdApi,
  getTaskListApi,
  hideLoader,
  LayoutResponseType,
  paySignCopayEnrollment,
  paySignSendEnrollmentFaxInvoke,
  previewAndDownload,
  RelationshipResponseTree,
  RELATIONSHIPS,
  showLoader,
  taskUpdateIdentifierApi,
  transformToDuplicateApiPayload,
  triggerInteractionStatusEvent,
  updateAutomationStagedDetails,
  updateEntityInstanceApi,
  updateIcdCodes,
  WORKFLOW_UI_IDENTIFIER,
  workflowFieldNameModification,
  WorkflowInstanceTaskType,
  WorkflowInstanceType,
  WorkflowProcessType,
  WorkflowTaskCompleteResponseType,
  WorkflowTaskIdentifierActionButtonsType,
  WorkflowTaskIdentifierType,
} from '@app-store'
import { EntityLayout, LayoutData, Page } from '../../types/layout.types'
import {
  addEntityData,
  editEntityData,
  editEntityDataEmbeddedAPI,
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import {
  CUSTOM_LAYOUTS_KEYS_LIST,
  DUPLICATE_POPUP,
  emailTemplate,
  ENTITY_FIELDS,
  ENTITY_ID,
  ENTITY_NAME,
  FIELD_VALUE_CONSTANTS,
  fieldKeyEntityMapping,
  HTTP_STATUS_CONSTANTS,
  LAYOUT_TYPE_NAMESPACE,
  MODAL_POPUP_ACTIONS,
  MODAL_TYPES,
  MODE_STATUS,
  NAMESPACES,
  PATIENT_DETAILS,
  PAYSIGN_ERROR_STATUS_CODES,
  RECORD_STATE,
  TASK_STATUS,
  WORKFLOW_ACTION_IDENTIFIER,
  WORKFLOW_MODAL_TYPES,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import {
  ConfirmDialog,
  CustomButton,
  CustomDialog,
  Modal,
  SkeletonLoader,
  SvgDownload,
  SvgSuccessTick,
  SvgView,
  SvgWarningNew,
  TableActionType,
  TENANTS,
} from '@ui-kit'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import { v4 as uuid } from 'uuid'
import { useNavigate, useParams } from 'react-router-dom'
import {
  isEmpty,
  get as getNestedValue,
  cloneDeep,
  uniqueId,
  noop,
} from 'lodash'
import {
  CaseInsuranceCase,
  EntityLayoutCasePanePropsTypes,
  EntityLayoutTaskPropsTypes,
  PatientInfoResponse,
  TaskMetaRefType,
  TaskResponseModalStateType,
} from '../../types/workflow.types'
import { FieldValues, useForm, UseFormReturn } from 'react-hook-form'
import MissingInformationModal from './MissingInformationModal'
import TabLayout from '../tabs/TabLayout'
import { FORM_CONSTANTS, RECORD_STATUS } from '../../constants/form.constants'
import { useFocusFirstElement } from '../../hooks/useFocusFirstFocusableElement'
import { PaysignErrorType, TabIndexMap } from '../../types/common'
import { generateTabIndexMap } from '../../utils/tab-indexing'
import { fetchDownloadUrlForSingleFIles } from '../../apis/fetchPresignedUrl.api'
import { AxiosError, AxiosResponse } from 'axios'
import {
  RenderNestedEntityLayoutTaskPropsType,
  SubmitButtonEntityLayoutPropsType,
} from '../../types/types'
import {
  removeCountryCode,
  logErrorMessage,
  formatNumberTwoDigits,
  getLatestActiveRecord,
  permissionObject,
  openNewWindow,
  toTitleCase,
  startPollingForIntake,
} from '../../utils/helperFunctions'
import { formatLocalDate } from '../../utils/date.utils'
import TaskNotesSuggestionBox from './TaskNotesSuggestion'
import PaySignErrorPopup from './PaySignErrorPopup'
import {
  CALL_INTERACTIONS,
  PAYSIGN_CONFIG_STRINGS,
  STRINGS,
} from '../../utils/strings'
import {
  isReadOnlyUser,
  isSuperAdmin,
  currentUserId,
} from '../../utils/permission'
import CheckEligibilityMaxRTE from '../max-rte/CheckEligibilityMaxRTE'
import {
  CHECK_ELIGIBILITY_LOCATION,
  MAX_RTE_NAME_SPACE,
} from '../../utils/maxRTE'
import HybridLayout from '../hybird-layout/HybridLayout'
import PatientEConsent from '../e-consent/PatientEConsent'
import EPRQueryButton from '../epr-integrations/EPRQueryButton'
import { DuplicatePopupModal } from './DuplicatePopupModal'
import { caseCancelOrVoidApi } from '../../apis/caseStatus.api'
import { ListingTableRow } from '../../types/listingTable.types'
import { DYNAMIC_QUEUE_CONSTANTS } from '../../constants/dynamicQueue'
import ShipmentDetailsOrderCaseCustom from './ShipmentDetailsOrderCaseCustom'
import {
  PENDING_INTAKE_POPUP_MESSAGE,
  QUICK_DENIAL_POPUP_MESSAGE,
} from '../../constants/formattedMessages'
import { showToasterMethod } from '../../utils/form.utils'
import { ModalType } from '../../utils/types'

export const EntityLayoutTask: FC<EntityLayoutTaskPropsTypes> = ({
  task,
  recordId,
  isTask,
  handleTaskResponse,
  selectCaseTaskRef,
  updateTaskResource,
  refetch,
  handleRefetchPane,
  refetchPane,
  updateStatusToProcessing,
  definition,
  instance,
  fromInteraction,
  onButtonClick,
  onDataFetch,
  tabIndexOffset = 10,
  taskList,
  isDisabled = false,
  refetchCounter,
  isMAXRTE = false,
  faxDetails,
  intakeEntityName,
}) => {
  const navigate = useNavigate()
  const MEC_PORTAL_BTN = true
  const memberShipIdObjectRef = useRef<FieldValues>({})
  const isPaysignSubmitApiSuccessful = useRef<boolean>()
  const isPaysignSendApiSuccessful = useRef<boolean>()
  const iscreateTaskApiSuccessful = useRef<boolean>()
  const [totalResults, setTotalResults] = useState(0)
  const [activeModal, setActiveModal] = useState<ModalType>(null)
  const [listingLayout, setListingLayout] = useState<
    LayoutResponseType | undefined
  >()
  const [modalHandlers, setModalHandlers] = useState<{
    onProceedAnyway?: () => void
    onCancel?: () => void
    isOpen?: boolean
  }>({})
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false)
  const [attachCaseId, setAttachCaseId] = useState<number | null>(null)
  const isDraft = useRef<boolean>(false)
  const [isPreview, setIsPreview] = useState<string | null>(null)
  const taskMetaRef = useRef<TaskMetaRefType>({
    isCreate: false,
    isEdit: false,
  })
  const authUser = useAppSelector((state) => state.authUser)
  const { communicationId, layoutid, caseId, entityid } = useParams()
  const containerRef = useRef<HTMLDivElement | null>(null)
  const paySignErrorInitialState: PaysignErrorType = {
    flag: false,
    heading: null,
    message: null,
  }
  const formMethodsRef = useRef<UseFormReturn<FieldValues> | null>(null)
  useFocusFirstElement(containerRef)
  const dispatch = useAppDispatch()
  const workflowDefinitionSelector = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const workflowInstanceSelector = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const workflowDefinition = definition || workflowDefinitionSelector
  const workflowInstance = instance || workflowInstanceSelector

  const relationshipTreeObject = useAppSelector(
    (state) => state?.workflowData?.relationShipTreeObject
  )
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)
  const programPermissions = useAppSelector(
    (state) => state?.clientPermissions?.programPermissions
  )
  const programServices = useAppSelector(
    (state) => state?.clientPermissions?.programServices
  )
  const userId = useAppSelector((state) => state.authUser?.user?.id)
  const selectedClientTenant = useAppSelector(
    (state) => state.authUser?.selectedClientTenant
  )
  const unresolvedDedupeEntities = useAppSelector(
    (state) => state.workflowData?.unresolvedDedupeEntities
  )
  const [layout, setLayout] = useState<LayoutResponseType | null>(null)
  const [associatedRecordId, setAssociatedRecordId] = useState<number>()
  const [recordData, setRecordData] = useState<FieldValues | null>(null)
  const [isLoader, setIsLoader] = useState(true)
  const [downloadFileData, setDownloadFileData] = useState()
  const [headerMessage, setHeaderMessage] = useState('')
  const [disableGetMemberIdButton, setDisableGetMemberIdButton] =
    useState(false)
  const [layoutMode, setLayoutMode] = useState<'add' | 'edit' | 'view' | ''>('')

  const [actionButtons, setActionButtons] =
    useState<WorkflowTaskIdentifierActionButtonsType>({
      ...task?.identifier?.action_buttons,
    })

  const [confirmationModalObject, setConfirmationModalObject] = useState<{
    type: string
    state: boolean
  }>({
    type: '',
    state: false,
  })
  const [taskNoteBoxId, setTaskNoteBoxId] = useState<string | undefined>()
  const submitFormButtonRef = useRef<HTMLButtonElement | null>(null)
  const draftSubmitFormButtonRef = useRef<HTMLButtonElement | null>(null)
  const draftRef = useRef(RECORD_STATUS.ACTIVE)
  const [tabIndexMap, setTabIndexMap] = useState<TabIndexMap>({})
  const [paysignErrorPopup, setPaysignErrorPopup] = useState<PaysignErrorType>(
    paySignErrorInitialState
  )
  const finalDataRef = useRef<FieldValues | null>(null)
  const { setValue, register, getValues } = useForm()
  const fetchData = async ({
    entityName,
    entityId,
    layoutId,
    dataId,
    layoutResponse,
    isCreate = false,
    isCreateAssociate = false,
    isEdit = false,
    isEditAssociated = false,
  }: {
    entityName: string
    entityId: number
    layoutId: number
    dataId: string
    layoutResponse: LayoutResponseType
    isCreate?: boolean
    isCreateAssociate?: boolean
    isEdit?: boolean
    isEditAssociated?: boolean
  }) => {
    try {
      const entityData = await getEntityData(
        entityName || '',
        entityId,
        layoutId,
        dataId
      )

      if (entityData?.data) {
        taskMetaRef.current = {
          ...taskMetaRef?.current,
          isCreate,
          isCreateAssociate,
          isEdit,
          isEditAssociated,
          entity_id: entityId?.toString(),
          entity_name: entityName,
          layout_id: layoutId?.toString(),
          record_id: entityData?.data?.id,
        }
        setRecordData(entityData?.data)
        onDataFetch?.(layout, entityData?.data)
        if (!isEmpty(layoutResponse?.layout_data?.header?.key)) {
          const response = await getEntityDataByIdEmbedded(
            entityName,
            entityId,
            layoutResponse?.layout_data?.header?.key || [],
            Number(dataId)
          )

          if (response?.data) {
            const headerString =
              layoutResponse?.layout_data?.header?.prefix ?? ''
            const mappedString = mapAndJoin(
              layoutResponse?.layout_data?.header?.key || [],
              response?.data,
              layoutResponse?.layout_data?.header?.delimiter ?? ''
            )
            setHeaderMessage(headerString + mappedString || '')
          }
        }
      }
    } catch (err) {
      console.error(err)
    }
  }
  const handleInitForm = (methods: UseFormReturn<FieldValues>) => {
    formMethodsRef.current = methods
  }
  function mapAndJoin(keys: string[], obj: FieldValues, delimiter: string) {
    // Map the keys to the corresponding values in the object
    const values = keys.map((key) => obj[key])

    // Join the values with the delimiter
    return values.join(delimiter)
  }
  const getDataId = (task: WorkflowInstanceTaskType) =>
    !isNaN(Number(task?.resource_id?.toString()))
      ? Number(task?.resource_id?.toString()).toString()
      : task?.resource_id?.toString()

  const getPrameters = (isWorkflowEntity: boolean) =>
    isWorkflowEntity ? { isEdit: true } : { isEditAssociated: true }

  const checkIfResponse = (
    isResponse: boolean,
    taskIdentifier: WorkflowTaskIdentifierType | undefined,
    layoutResponse: AxiosResponse<LayoutResponseType>,
    taskRelatedEntity: RelationshipResponseTree | undefined
  ) => {
    if (!isResponse) {
      taskMetaRef.current = {
        ...taskMetaRef?.current,
        isCreateAssociate: true,
        entity_id: taskIdentifier?.entity_id,
        entity_name: layoutResponse?.data?.entity_name,
        layout_id: `${layoutResponse?.data?.id ?? 0}`,
        record_id: recordId,
        relation_identifier: taskRelatedEntity?.relation_identifier,
        field_name: taskRelatedEntity?.field_name ?? '',
        mapped_as: taskRelatedEntity?.mapped_as ?? '',
      }
    }
  }
  const handleFetchInfo = async (
    isResponse: boolean,
    taskIdentifier: WorkflowTaskIdentifierType | undefined,
    layoutResponse: AxiosResponse<LayoutResponseType>,
    taskRelatedEntity: RelationshipResponseTree | undefined,
    relatedResponse: FieldValues
  ) => {
    checkIfResponse(
      isResponse,
      taskIdentifier,
      layoutResponse,
      taskRelatedEntity
    )
    if (
      isResponse &&
      (taskRelatedEntity?.mapped_as === RELATIONSHIPS?.ONE_TO_MANY ||
        taskRelatedEntity?.mapped_as === RELATIONSHIPS?.ONE_TO_ONE ||
        taskRelatedEntity?.mapped_as === RELATIONSHIPS?.MANY_TO_ONE)
    ) {
      setAssociatedRecordId(
        relatedResponse?.data?.[
          taskRelatedEntity?.field_name ?? ''
        ]?.id?.toString()
      )
      await fetchData({
        entityName: layoutResponse?.data?.entity_name ?? '',
        entityId: Number(taskIdentifier?.entity_id),
        layoutId: Number(layoutResponse?.data?.id),
        dataId:
          relatedResponse?.data?.[taskRelatedEntity?.field_name ?? '']?.id,
        layoutResponse: layoutResponse?.data,
        isEditAssociated: true,
      })
    }
  }
  const fetchInfo = async () => {
    setIsLoader(true)
    const taskIdentifier = task?.identifier
    const workflowEntity = {
      entityId:
        workflowDefinition?.definition?.processVariables?.entity_id?.toString() ??
        '',
      entityName:
        workflowDefinition?.definition?.processVariables?.entity_name ?? '',
    }
    const taskFieldName = workflowFieldNameModification(
      taskIdentifier?.field_name ?? workflowEntity?.entityName ?? ''
    )
    const taskRelatedEntity = getNestedValue(
      relationshipTreeObject,
      taskFieldName
    )
    try {
      const layoutResponse = await getLayoutByIdApi({
        layoutId:
          layoutMode === 'view'
            ? taskIdentifier?.view_layout_id ??
              taskIdentifier?.layout_info?.layout_id
            : taskIdentifier?.layout_info?.layout_id,
        entityId: taskIdentifier?.entity_id,
      })
      if (layoutResponse.data) {
        const isWorkflowEntity =
          workflowEntity.entityId ===
          layoutResponse?.data?.entity_id?.toString()
        if (
          !isWorkflowEntity &&
          layoutResponse?.data?.entity_id?.toString() !==
            taskIdentifier?.entity_id?.toString()
        ) {
          setLayout(null)
        } else {
          setLayout(layoutResponse?.data ?? null)
          onDataFetch?.(layoutResponse?.data, null)
        }
        if (task?.resource_id) {
          const lt =
            task?.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER?.CUSTOM_LAYOUT_SCREEN
              ? workflowDefinition?.definition?.processVariables?.left_split
                  ?.edit_layout_id
              : layoutResponse?.data?.id
          await fetchData({
            entityName: layoutResponse?.data?.entity_name ?? '',
            entityId: Number(taskIdentifier?.entity_id),
            layoutId: Number(lt),
            dataId: getDataId(task) ?? '',
            layoutResponse: layoutResponse?.data,
            ...getPrameters(isWorkflowEntity),
          })
        } else if (isWorkflowEntity) {
          const lt =
            task?.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER?.CUSTOM_LAYOUT_SCREEN
              ? workflowDefinition?.definition?.processVariables?.left_split
                  ?.edit_layout_id
              : layoutResponse?.data?.id
          await fetchData({
            entityName: layoutResponse?.data?.entity_name ?? '',
            entityId: Number(taskIdentifier?.entity_id),
            layoutId: Number(lt),
            dataId: recordId?.toString(),
            layoutResponse: layoutResponse?.data,
            isEdit: true,
          })
        } else {
          const relatedResponse = await getEntityDataByIdEmbedded(
            workflowEntity?.entityName || '',
            Number(workflowEntity?.entityId || ''),
            [taskRelatedEntity?.field_name ?? ''],
            Number(recordId)
          )
          if (relatedResponse?.data) {
            const isResponse = !isEmpty(
              relatedResponse?.data?.[taskRelatedEntity?.field_name ?? '']
            )
            await handleFetchInfo(
              isResponse,
              taskIdentifier,
              layoutResponse,
              taskRelatedEntity,
              relatedResponse
            )
          }
        }
      }
      fetchTaskNotesData()
    } catch (err) {
      logErrorMessage('taskNotes', err)
    } finally {
      setIsLoader(false)
    }
  }
  const fetchTaskNotesData = async () => {
    const payload = {
      entity_name:
        workflowDefinition?.global_variables?.entities?.task?.entity_name ??
        NAMESPACES.TASK,
      select: ['c_case_notes_task', NAMESPACES.NAME_KEY],
      filters: [
        {
          criteria: [],
        },
      ],
      related_entities: {
        c_case_notes_task: {
          select: [NAMESPACES.NAME_KEY],
          criteria: [
            {
              criteria: [],
            },
          ],
        },
      },
    }
    const responseData = await getGenericEntityListingAPI(payload, task?.id)
    if (responseData?.c_case_notes_task?.[0]?.id) {
      setTaskNoteBoxId(responseData?.c_case_notes_task?.[0]?.id)
      setValue(
        `taskNotes${task?.task_id}`,
        responseData?.c_case_notes_task?.[0]?.name
      )
    } else if (
      !isEmpty(task?.identifier?.order_notes) &&
      task?.identifier?.taskNoteValues?.isTaskNoteSuggestionBox
    ) {
      editEntityDataEmbeddedAPI(
        workflowDefinition?.global_variables?.entities?.task?.entity_name ??
          NAMESPACES.TASK,
        task?.id ?? '',
        {
          c_case_notes_task: [
            {
              name: task?.identifier?.order_notes,
              source: NAMESPACES.TASK,
              headers: `T${formatNumberTwoDigits(
                task?.task_id ? +task?.task_id : 0
              )}- ${task?.name}`,
              ...(taskNoteBoxId ? { id: taskNoteBoxId } : {}),
              _state: NAMESPACES.CHANGED,
              case: {
                id: task?.case_id,
                _state: NAMESPACES.CHANGED,
              },
              ...(!taskNoteBoxId ? { users_id: currentUserId() ?? '' } : {}),
            },
          ],
          record_status: TASK_STATUS.ACTIVE,
        },
        ['c_case_notes_task']
      )
      setValue(`taskNotes${task?.task_id}`, task?.identifier?.order_notes)
    }
  }
  const fetchPatientInfo = async (): Promise<
    PatientInfoResponse | undefined
  > => {
    try {
      const programEntity = relationshipTree?.find(
        (item) =>
          item?.entity_id?.toString() ===
          workflowDefinition?.global_variables?.entities?.program?.entity_id
      )
      const caseEntity = relationshipTree?.find(
        (item) =>
          item?.entity_id?.toString() ===
          workflowDefinition?.global_variables?.entity_id
      )

      if (!isEmpty(programEntity) && !isEmpty(caseEntity)) {
        const response = await getEntityDataByIdEmbedded(
          workflowDefinition?.global_variables?.entity_name ?? '',
          Number(workflowDefinition?.global_variables?.entity_id),
          [programEntity?.field_name ?? ''],
          Number(recordId)
        )
        if (response) {
          const patientPreferredPhoneNumber = {
            c_patient_phones_c_patients: {
              select: [
                'phone_number',
                'is_preferred',
                'phone_type',
                'modified_at',
                'created_at',
              ],
            },
          }
          const providerPreferredFaxNumber = {
            c_provider_phones_c_providers: {
              select: [
                'phone_number',
                'is_preferred',
                'phone_type',
                'modified_at',
                'created_at',
              ],
            },
          }
          const patientPayload = {
            entity_name: 'case',
            select: ['patient', 'products', 'c_provider'],
            filters: [
              {
                logical_oprator: 'AND',
              },
            ],
            related_entities: {
              patient: {
                select: PATIENT_DETAILS,
                related_entities: patientPreferredPhoneNumber,
              },
              c_provider: {
                select: [
                  'c_provider_phones_c_providers',
                  'p_contacts',
                  'first_name',
                  'last_name',
                ],
                related_entities: providerPreferredFaxNumber,
              },
            },
          }
          const patientResponse = await getGenericEntityListingAPI(
            patientPayload as unknown as GetGenericEntityListingApiType,
            workflowInstance?.case_id
          )
          const latestPatientPhoneNumber = removeCountryCode(
            getLatestActiveRecord(
              patientResponse?.patient?.c_patient_phones_c_patients,
              emailTemplate.PHONE
            )?.phone_number ?? ''
          )
          const patientDetails = {
            first_name: patientResponse?.patient?.first_name,
            last_name: patientResponse?.patient?.last_name,
            gender: patientResponse?.patient?.gender?.value.toUpperCase(),
            date_of_birth: formatLocalDate(
              patientResponse?.patient?.date_of_birth,
              'MM/DD/YYYY'
            ),
            phone: latestPatientPhoneNumber,
          }
          const providerFaxes =
            getLatestActiveRecord(
              patientResponse?.c_provider?.c_provider_phones_c_providers,
              emailTemplate.Fax
            )?.phone_number ?? ''

          const providerFaxNumber = {
            fax_number: removeCountryCode(providerFaxes),
            first_name: patientResponse?.c_provider?.first_name,
            last_name: patientResponse?.c_provider?.last_name,
          }
          const productName = patientResponse?.products?.trademarked_name
          return {
            patientInfo: patientDetails,
            providerInfo: providerFaxNumber,
            productName: productName,
            products: patientResponse?.products,
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleSaveButton = () => {
    if (unresolvedDedupeEntities?.length > 0) {
      setActiveModal(WORKFLOW_MODAL_TYPES.UNRESOLVED_DEDUPE)
      return
    }
    draftRef.current = RECORD_STATUS.ACTIVE
    submitFormButtonRef?.current?.click()
  }

  const handleSaveDraft = async () => {
    if (workflowDefinition?.global_variables?.multiIntake) {
      const dataForEmbedded = {
        id: workflowInstance?.case_id,
        user_id: userId,
      }
      await editEntityDataEmbeddedAPI(
        String(ENTITY_ID.CASE),
        workflowInstance?.case_id ?? '',
        dataForEmbedded,
        ['user_id'],
        true
      )
    }
    draftRef.current = RECORD_STATUS.DRAFT
    draftSubmitFormButtonRef?.current?.click()
  }
  const updateTaskIdentifier = async (
    task: WorkflowInstanceTaskType | null
  ) => {
    try {
      await taskUpdateIdentifierApi({
        taskId: task?.id ?? '',
        data: {
          entity_data: {},
          task: {
            ...(task?.identifier && {
              identifier: {
                ...task?.identifier,
                disable_get_member_id: true,
              },
            }),
          },
        },
      })
    } catch (err) {
      console.error(err)
    }
  }

  const getPaysignErrorHeader = (message: string, code: string): string => {
    const errorCode = Number(code)

    if (errorCode === 400) {
      if (
        message
          ?.toLowerCase()
          .includes(PAYSIGN_CONFIG_STRINGS.ALREADY_ENROLLED_LOWERCASE)
      ) {
        return PAYSIGN_CONFIG_STRINGS.ALREADY_ENROLLED
      } else {
        return PAYSIGN_CONFIG_STRINGS.ENROLLMENT_PROCESSING_ERROR
      }
    }

    if (PAYSIGN_ERROR_STATUS_CODES.includes(errorCode)) {
      return PAYSIGN_CONFIG_STRINGS.COPAY_VENDOR_ERROR
    }

    return PAYSIGN_CONFIG_STRINGS.UNKNOWN_ERR
  }

  const getPaysignErrorMessage = (
    body:
      | string
      | {
          message?: string
          body?: string
        }
  ) => {
    if (typeof body === 'string') {
      return body
    }
    return body?.message ?? body?.body ?? ''
  }

  const handlePaysignError = async (error: AxiosError) => {
    const errorMessage = (error as AxiosError)?.response?.data as ErrorResponse
    if (errorMessage?.message) {
      dispatch(
        addToaster({
          message: errorMessage?.message,
          type: 'error',
          id: uuid(),
        })
      )
    }

    const payload: GetGenericEntityListingApiType = {
      entity_name: ENTITY_NAME.CASE_LOWER,
      select: [ENTITY_NAME.PATIENT],
      filters: [],
      related_entities: {
        patient: {
          select: ['id', 'patient_key'],
          criteria: [],
        },
      },
    }
    const patientResponse = await getGenericEntityListingAPI(payload, recordId)
    if (patientResponse) {
      const requestorPayload = {
        entity_name: ENTITY_NAME.REQUESTOR_VIEW,
        select: ['id', 'record_key'],
        page: 0,
        size: 1,
        filters: [
          {
            criteria: [
              {
                field_name: 'record_key',
                operation: 'LIKE',
                values: [`${patientResponse?.patient?.patient_key}`],
              },
            ],
          },
        ],
      }
      const patientRequestorView = await getEntityDataByEntityNameApiForFilter({
        payload: requestorPayload,
      })
      if (patientRequestorView) {
        try {
          await createTaskApi({
            case_id: workflowInstance?.case_id ?? '',
            name: NAMESPACES?.TRANSFER_TO_COPAY_VENDOR,
            description: '',
            state: NAMESPACES?.PENDING,
            standalone: true,
            record_status: TASK_STATUS.ACTIVE,
            due_date: task?.due_date?.toString() ?? '',
            process_instance_id: workflowInstance?.id ?? '',
            identifier: {
              ui_identifier: '',
              disable_get_member_id: true,
              taskNoteValues: {
                isTaskNoteSuggestionBox: true,
                isTaskNoteAddButton: false,
              },
            },
            task_template: {
              id: 2,
            },
            assignee: {
              id: Number(task?.assignee?.id),
            },
            requestor_view: {
              id: patientRequestorView?.data?.content?.[0].id,
            },
            entity_type_name: 'Organization',
            entity_name: 'Organization',
          })
          iscreateTaskApiSuccessful.current = true
        } catch (err) {
          iscreateTaskApiSuccessful.current = false
          console.error(err)
          dispatch(
            addToaster({
              message: STRINGS.ERROR_CREATING_TASK,
              type: 'error',
              id: uuid(),
            })
          )
        }
        console.error(error)
      }
    }
  }

  const handleGetMemberIdButton = async () => {
    try {
      dispatch(showLoader())
      const info: PatientInfoResponse | undefined = await fetchPatientInfo()
      const productName = info?.productName?.replace(/®/g, '').trim() ?? ''

      const hasAuthorization = await paySignCopayEnrollment(
        {
          ...info?.patientInfo,
        },
        productName
      )
      const cardDetails = hasAuthorization?.data?.body
      if (
        hasAuthorization?.data?.statusCode === HTTP_STATUS_CONSTANTS.SUCCESS
      ) {
        isPaysignSubmitApiSuccessful.current = true
        const metaData = {
          bin: cardDetails?.BIN,
          card_effectivity_date: formatLocalDate(
            cardDetails?.card_effectivity_date,
            'YYYY-MM-DD',
            true
          ),
          grp: cardDetails?.GROUP,
          member_id: cardDetails?.member_id,
          pcn: cardDetails?.PCN,
          product: info?.products,
        }
        memberShipIdObjectRef.current = metaData
        setDisableGetMemberIdButton(true)
        const shouldInvokeFax = await checkPaySignFlowAPI(productName)

        let hasInvoke = {
          data: { body: '', statusCode: HTTP_STATUS_CONSTANTS.SUCCESS },
        }

        if (shouldInvokeFax?.data?.body?.sendEnrollmentFaxSupported) {
          const providerName = `${info?.providerInfo?.first_name ?? ''} ${
            info?.providerInfo?.last_name ?? ''
          }`
          hasInvoke = await paySignSendEnrollmentFaxInvoke(
            {
              member_number: cardDetails?.member_id,
              recipient_name: providerName.trim(),
              recipient_fax: info?.providerInfo?.fax_number,
            },
            productName
          )
        }
        if (
          !(
            shouldInvokeFax?.data?.statusCode ===
              HTTP_STATUS_CONSTANTS.SUCCESS &&
            hasInvoke?.data?.statusCode === HTTP_STATUS_CONSTANTS.SUCCESS
          )
        ) {
          let errorMessage = TOASTER_NAMESPACE.PATIENT_ALREADY_ENROLLED
          if (hasInvoke?.data?.statusCode !== HTTP_STATUS_CONSTANTS.SUCCESS) {
            isPaysignSendApiSuccessful.current = false
            errorMessage = getPaysignErrorMessage(hasInvoke?.data?.body)
            setPaysignErrorPopup({
              flag: true,
              heading: getPaysignErrorHeader(
                getPaysignErrorMessage(hasInvoke?.data?.body),
                hasInvoke?.data?.statusCode?.toString()
              ),
              message: errorMessage,
            })
          }

          throw new Error(errorMessage)
        } else if (
          hasInvoke?.data?.statusCode === HTTP_STATUS_CONSTANTS.SUCCESS
        ) {
          isPaysignSendApiSuccessful.current = true
        }
      } else {
        isPaysignSubmitApiSuccessful.current = false
        const errorMessage = getPaysignErrorMessage(
          hasAuthorization?.data?.body
        )
        setPaysignErrorPopup({
          flag: true,
          heading: getPaysignErrorHeader(
            getPaysignErrorMessage(hasAuthorization?.data?.body),
            hasAuthorization?.data?.statusCode
          ),
          message: errorMessage,
        })
        throw new Error(errorMessage)
      }
    } catch (error) {
      await handlePaysignError(error as AxiosError)
    } finally {
      await updateTaskIdentifier(task) //NOTE: disables getMemberIdAndSave button, no matter first api fails or passes
      if (isPaysignSubmitApiSuccessful?.current) {
        //NOTE: if second API has failed, then create task and saveForm and workflow will reload
        //NOTE: if first API is successful , then submit form and workflow will reload itself
        await handleSaveButton()
      } else if (iscreateTaskApiSuccessful?.current) {
        refetch?.() //NOTE: if first API fails and task is created successfully and then workflow is forced to reload
      }
      dispatch(hideLoader())
    }
  }

  const handleNavigation = (
    response: FieldValues,
    workflowDefinition: WorkflowProcessType | null,
    fromInteraction: boolean | undefined,
    workflowInstance: WorkflowInstanceType | null
  ) => {
    if (response.data?.content?.length) {
      if (response.data?.content[0]?.task_id !== task?.task_id) {
        const url = `/entity/${workflowDefinition?.definition?.processVariables?.entity_id}/workflow/review/${workflowInstance?.case_id}`
        if (fromInteraction) {
          window.open(url, '_blank', 'noopener,noreferrer')
        } else {
          navigate(url)
        }
        return true
      }
    }
  }

  const handleCompleteTask = async () => {
    setActiveModal(null)
    navigate('../')
  }

  const MODAL_CONTENT: Record<
    Exclude<ModalType, null>,
    () => React.ReactNode
  > = {
    PENDING_INTAKE: () => (
      <>
        <SvgSuccessTick />
        <span className="text-base font-medium">
          {NAMESPACES.PENDING_INTAKE_POPUP_HEADER}
        </span>
        <div className="text-xs leading-snug text-center">
          {PENDING_INTAKE_POPUP_MESSAGE}
        </div>
        <CustomButton
          isFilled
          onClick={() => {
            setActiveModal(null)
            if (fromInteraction) onButtonClick?.()
            else navigate('../')
          }}
        >
          {MODAL_POPUP_ACTIONS.OK_UPPERCASE}
        </CustomButton>
      </>
    ),

    QUICK_DENIAL: () => (
      <>
        <SvgSuccessTick />
        <span className="text-base font-medium">
          {NAMESPACES.QUICK_DENIED_POPUP_HEADER}
        </span>
        <div className="text-xs leading-snug text-center">
          {QUICK_DENIAL_POPUP_MESSAGE}
        </div>
        <CustomButton isFilled onClick={handleCompleteTask}>
          {MODAL_POPUP_ACTIONS.OK_UPPERCASE}
        </CustomButton>
      </>
    ),

    UNRESOLVED_DEDUPE: () => (
      <>
        <SvgWarningNew />
        <span className="text-base font-medium">
          {NAMESPACES.ACTION_REQUIRED}
        </span>
        <div className="text-xs leading-snug">
          <p>{NAMESPACES.UNRESOLVED_DEDUPE_ENTITIES_POPUP_HEADER}</p>
          <ul className="list-disc pl-5 mt-2 text-left">
            {unresolvedDedupeEntities.map((entityKey) => (
              <li key={entityKey}>
                <b>
                  {toTitleCase(fieldKeyEntityMapping[entityKey]) ?? entityKey}
                </b>
              </li>
            ))}
          </ul>
        </div>
      </>
    ),
  }
  const handeNavigation2 = (
    workflowDefinition: WorkflowProcessType | null,
    fromInteraction: boolean | undefined,
    taskResponse: FieldValues,
    workflowInstance: WorkflowInstanceType | null
  ) => {
    if (
      workflowDefinition?.definition?.processVariables?.inherited_variables
        ?.show_mi_popup === false
    ) {
      const url = `/entity/${workflowDefinition?.definition?.processVariables?.entity_id}/workflow/review/${workflowInstance?.case_id}`
      if (fromInteraction) {
        window.open(url, '_blank', 'noopener,noreferrer')
      } else {
        navigate(url)
      }
    } else {
      handleTaskResponse?.(taskResponse?.data, true)
    }
  }
  const updateStatus = async (status: string) => {
    try {
      const response = await fetchTypeStatusForCommunications(
        NAMESPACES.WEB_ENROLLMENT_STATUS
      )
      const webEnrollmentStatusId = response?.data?.find(
        (item: { value: string }) => item?.value?.toLowerCase() === status
      )?.id
      if (webEnrollmentStatusId) {
        await discardWebIntakeApi(
          parseInt(communicationId ?? ''),
          parseInt(entityid ?? ''),
          parseInt(layoutid ?? ''),
          {
            enrollment_status: {
              id: webEnrollmentStatusId,
              _state: RECORD_STATE.CHANGED,
            },
            // case_id: workflowInstance?.case_id,
            reason: '',
          }
        )
      }
    } catch (err) {
      showToasterMethod(NAMESPACES.SOMETHING_WENT_WRONG_STATUS_UPDATE, dispatch)
    }
  }
  const completeTask = async () => {
    try {
      let meta_data: { entityId?: string; layoutId?: string } = {}
      let forced = false
      let isPrerequisite = false
      if (
        !isEmpty(
          workflowDefinition?.definition?.steps?.[task?.step_id ?? '']
            ?.preRequisite
        )
      ) {
        meta_data = {
          // entityId: task?.identifier?.entity_id,
          // layoutId: task?.identifier?.layout_info?.layout_id,
        }
        isPrerequisite = true
      }
      if (
        workflowDefinition?.definition?.steps?.initializationSubProcess
          ?.steps?.[task?.step_id ?? '']?.identifier?.task_completed_forced
      ) {
        forced = true
      }
      if (draftRef?.current === RECORD_STATUS.DRAFT) {
        handleRefetchPane?.()
      }
      if (!isTask && draftRef?.current === RECORD_STATUS.ACTIVE) {
        const response = await getTaskListApi({
          search_criteria: [
            {
              search_key: 'CASE_ID',
              search_value: [recordId],
              operator: 'EQUALS',
            },
          ],
        })
        if (workflowDefinition?.global_variables?.multiIntake) {
          const dataForEmbedded = {
            id: workflowInstance?.case_id,
            user_id: userId,
          }
          await editEntityDataEmbeddedAPI(
            String(ENTITY_ID.CASE),
            workflowInstance?.case_id ?? '',
            dataForEmbedded,
            ['user_id'],
            true
          )
        }

        if (
          handleNavigation(
            response,
            workflowDefinition,
            fromInteraction,
            workflowInstance
          )
        )
          return

        if (
          workflowDefinition?.definition?.processVariables?.inherited_variables
            ?.show_mi_popup === false
        ) {
          const programId =
            caseData?.programs?.id ?? workflowDefinition?.program_id
          const serviceId =
            caseData?.services?.id ?? workflowDefinition?.service_id
          if (
            !isSuperAdmin() &&
            !programServices[programId ?? '']?.includes(serviceId ?? 0)
          ) {
            await editEntityDataEmbeddedAPI(
              workflowDefinition?.global_variables?.entity_name ?? '',
              taskMetaRef?.current?.record_id?.toString() ?? '',
              {
                entityName:
                  workflowDefinition?.global_variables?.entity_name ?? '',
                users: {
                  _state: 'REMOVED',
                },
              },
              ['users']
            )
          }
        }

        const taskResponse = await completeTaskByTaskIdApi({
          taskId: task?.id ?? '',
          meta_data,
          forced,
        })
        if (
          taskResponse?.status === 202 ||
          taskResponse?.data?.instance?.state ===
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
        ) {
          const poolingResponse: FieldValues = await startPollingForIntake({
            caseId: !isTask ? recordId?.toString() ?? '' : caseId ?? '',
          })
          taskResponse.data = {
            instance: poolingResponse?.workflow_instance,
            preRequisiteExecuted: isPrerequisite,
          }
          if (
            !isEmpty(poolingResponse?.workflow_instance?.background_response)
          ) {
            taskResponse.data.checkerResult =
              poolingResponse?.workflow_instance?.background_response ?? null
          }
        }
        if (taskResponse?.data && selectCaseTaskRef) {
          if (instance?.case_id && Number(taskMetaRef?.current?.layout_id)) {
            if (
              workflowDefinition?.global_variables?.multiIntake &&
              taskResponse?.data?.checkerResult?.quickDenialDetails?.denied
            ) {
              await updateStatus(NAMESPACES.DENIED_COMPLETED_LOWERCASE)
              await completeTaskByTaskIdApi({
                taskId: task?.id ?? '',
                forced: true,
                meta_data,
              })
              setActiveModal(WORKFLOW_MODAL_TYPES.QUICK_DENIAL)
              return
            }
            if (
              taskResponse?.data?.checkerResult?.data
                .case_automation_event_completed === false
            ) {
              await updateEntityInstanceApi(
                ENTITY_NAME?.CASE_LOWER,
                parseInt(instance.case_id),
                ENTITY_ID.CASE,
                Number(taskMetaRef?.current?.layout_id),
                {
                  record_status: RECORD_STATUS.DRAFT,
                }
              )
              if (unresolvedDedupeEntities?.length === 0) {
                updateStatus(NAMESPACES.PENDING_INTAKE_LOWERCASE)
              }
              setActiveModal(WORKFLOW_MODAL_TYPES.PENDING_INTAKE)
              return
            }
          }
          selectCaseTaskRef.current = task || null
          handeNavigation2(
            workflowDefinition,
            fromInteraction,
            taskResponse,
            workflowInstance
          )
        } else if (
          isEmpty(taskResponse?.data) &&
          taskResponse?.status === 200
        ) {
          addToaster({
            id: uuid(),
            type: 'success',
            message: STRINGS.ALLOW_POPUP_MESSAGE,
          })
          const url = `/entity/${workflowDefinition?.definition?.processVariables?.entity_id}/workflow/review/${workflowInstance?.case_id}`
          window.open(url, '_blank', 'noopener,noreferrer')
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  const customProcedure = async (resource_id: string, icd_codes: string[]) => {
    try {
      const icd_codes_formatted = icd_codes?.join(', ')
      await updateIcdCodes(recordId, resource_id, icd_codes_formatted ?? '')
    } catch (err) {
      console.error(err)
    }
  }
  const handleNavigationToHome = (fromInteraction: boolean | undefined) => {
    if (!fromInteraction) navigate('../')
  }
  const handleSubmitFlow = async (
    isTask: boolean | undefined,
    task: WorkflowInstanceTaskType | null,
    responseId: string,
    fromInteraction: boolean | undefined,
    showToaster = true
  ) => {
    try {
      if (!responseId) return

      if (isTask) {
        if (showToaster) {
          dispatch(
            addToaster({
              id: uuid(),
              type: 'success',
              message: TOASTER_NAMESPACE.ADD_SUCCESS,
            })
          )
        }
        await updateTaskResource?.(task, { resource_id: responseId })
        return
      }

      await completeTask()
      if (draftRef?.current === RECORD_STATUS.ACTIVE) {
        dispatch(
          addToaster({
            id: uuid(),
            type: 'success',
            message: TOASTER_NAMESPACE.SAVE_SUCCESS,
          })
        )
      } else if (draftRef?.current === RECORD_STATUS.DRAFT) {
        handleNavigationToHome(fromInteraction)
        !workflowDefinition?.global_variables?.multiIntake &&
          updateStatusToProcessing?.()
        dispatch(
          addToaster({
            id: uuid(),
            type: 'success',
            message: TOASTER_NAMESPACE.DRAFT_SAVE_SUCCESS,
          })
        )
      }
    } catch (err) {
      console.error(err)
    }
  }
  const getFinalData = (finalData: FieldValues, data: FieldValues) => {
    if (
      taskMetaRef?.current?.mapped_as === RELATIONSHIPS?.ONE_TO_MANY ||
      taskMetaRef?.current?.mapped_as === RELATIONSHIPS?.MANY_TO_MANY
    ) {
      return {
        ...finalData,
        [taskMetaRef?.current?.field_name ?? '']: [
          {
            ...data,
            _state: 'ADDED',
          },
        ],
      }
    } else {
      return {
        ...finalData,
        [taskMetaRef?.current?.field_name ?? '']: {
          ...data,
        },
      }
    }
  }
  // Helper to handle create associate logic
  const handleCreateAssociate = async (
    workflowEntity: { entityName: string; entityId: string; layoutId: string },
    finalData: FieldValues
  ) => {
    const response = await editEntityData(
      workflowEntity?.entityName || '',
      Number(workflowEntity?.entityId),
      Number(workflowEntity?.layoutId),
      finalData,
      taskMetaRef?.current?.record_id?.toString() ?? ''
    )

    if (response?.data) {
      const embeddedResponse = await getEntityDataByIdEmbedded(
        workflowEntity?.entityName || '',
        Number(workflowEntity?.entityId),
        [taskMetaRef?.current?.field_name ?? ''],
        Number(response?.data?.id)
      )
      const isResponse = !isEmpty(
        embeddedResponse?.data?.[taskMetaRef?.current?.field_name ?? '']
      )
      if (isResponse) {
        await handleSubmitFlow(
          isTask,
          task,
          embeddedResponse?.data?.[taskMetaRef?.current?.field_name ?? '']?.id,
          fromInteraction,
          false
        )
      }

      dispatch(
        addToaster({
          id: uuid(),
          type: 'success',
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
        })
      )
      refetch?.()
    }
  }

  // Helper to handle edit logic
  const handleEdit = async (finalData: FieldValues) => {
    const icdCode = finalData?.icd_code
    if (
      task?.identifier?.sub_ui_identifier ===
      WORKFLOW_UI_IDENTIFIER.PAP_EXECPTION_REVIEW_SUB_UI_IDENTIFIER
    ) {
      delete finalData?.icd_code
    }
    const response = await editEntityData(
      taskMetaRef?.current?.entity_name ?? '',
      Number(taskMetaRef?.current?.entity_id),
      Number(taskMetaRef?.current?.layout_id),
      finalData,
      taskMetaRef?.current?.record_id?.toString() ?? ''
    )
    if (
      response &&
      task?.identifier?.sub_ui_identifier ===
        WORKFLOW_UI_IDENTIFIER.PAP_EXECPTION_REVIEW_SUB_UI_IDENTIFIER
    ) {
      await customProcedure(response?.data?.id, icdCode ?? [])
    }
    await handleSubmitFlow(isTask, task, response?.data?.id, fromInteraction)
  }

  // Helper to handle after submit logic
  const handleAfterSubmit = async () => {
    if (
      task?.identifier?.taskNoteValues?.isTaskNoteSuggestionBox &&
      getValues(`taskNotes${task?.task_id}`)?.length
    ) {
      // TODO
      // c_case_notes_task remove this when get from definition
      editEntityDataEmbeddedAPI(
        workflowDefinition?.global_variables?.entities?.task?.entity_name ??
          NAMESPACES.TASK,
        task?.id ?? '',
        {
          c_case_notes_task: [
            {
              name: getValues(`taskNotes${task?.task_id}`),
              source: NAMESPACES.TASK,
              headers: `T${formatNumberTwoDigits(
                task?.task_id ? +task?.task_id : 0
              )}- ${task?.name}`,
              ...(taskNoteBoxId ? { id: taskNoteBoxId } : {}),
              _state: NAMESPACES.CHANGED,
              case: {
                id: task?.case_id,
                _state: NAMESPACES.CHANGED,
              },
              ...(!taskNoteBoxId ? { users_id: currentUserId() ?? '' } : {}),
            },
          ],
          record_status: TASK_STATUS.ACTIVE,
        },
        ['c_case_notes_task']
      )
    }
    if (fromInteraction) {
      const updatedCase = await getEntityData(
        taskMetaRef?.current?.entity_name ?? '',
        Number(taskMetaRef?.current?.entity_id),
        Number(taskMetaRef?.current?.layout_id),
        taskMetaRef?.current?.record_id?.toString() ?? ''
      )
      onDataFetch?.(null, updatedCase?.data)
      if (
        workflowDefinition?.definition?.processVariables?.inherited_variables
          ?.show_mi_popup === false
      ) {
        onButtonClick && onButtonClick()
      }
    }
  }
  const duplicateActions: TableActionType<DataTypeStore>[] = [
    {
      label: fromInteraction ? DUPLICATE_POPUP?.LINK : NAMESPACES?.ATTACH,
      key: fromInteraction
        ? DUPLICATE_POPUP?.LINK_KEY
        : DUPLICATE_POPUP?.ATTACH_KEY,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row, rowIndex, onActionClick) => {
        return (
          <button
            type="button"
            className="flex items-center justify-center font-normal text-xs w-[4.313rem] h-[1.75rem] rounded border border-primary-500 hover:bg-primary-100"
            onClick={() =>
              onActionClick(
                fromInteraction
                  ? DUPLICATE_POPUP?.LINK_KEY
                  : DUPLICATE_POPUP?.ATTACH_KEY,
                row,
                rowIndex
              )
            }
          >
            {fromInteraction ? DUPLICATE_POPUP?.LINK : NAMESPACES?.ATTACH}
          </button>
        )
      },
    },
  ]
  const handleDuplicateTableActions = (
    actionKey: string,
    row: ListingTableRow
  ) => {
    if (actionKey === DUPLICATE_POPUP?.LINK_KEY) {
      setAttachCaseId(Number(row?.id))
      setIsLinkModalOpen(true)
    }

    if (actionKey === DUPLICATE_POPUP?.ATTACH_KEY) {
      setAttachCaseId(Number(row?.id))
    }
  }
  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId:
          workflowDefinition?.definition?.processVariables?.entity_id?.toString() ??
          taskMetaRef?.current?.entity_id?.toString() ??
          '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })

      if (res?.data) {
        setListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.log(err)
    }
  }
  const showDuplicateModal = (): Promise<boolean> => {
    return new Promise((resolve) => {
      dispatch(hideLoader())

      const handleProceed = () => {
        setModalHandlers({})
        resolve(true)
      }

      const handleCancel = () => {
        setModalHandlers({})
        resolve(false)
      }

      setModalHandlers(() => ({
        onProceedAnyway: handleProceed,
        onCancel: handleCancel,
        isOpen: true,
      }))
    })
  }

  const isEmptySubFormObject = (obj: {
    _state?: string
    [key: string]: unknown
  }) => {
    if (obj._state === 'REMOVED') return true

    const allowedKeys = ['id', '_state', 'record_status']
    const otherKeysExist = Object.keys(obj).some(
      (k) => !allowedKeys.includes(k)
    )

    return Object.entries(obj).every(([key, value]) => {
      if (!otherKeysExist && key === 'id') {
        return value === null || value === undefined || value === ''
      }

      if (
        otherKeysExist &&
        (key === '_state' || key === 'record_status' || key === 'id')
      )
        return true

      return value === null || value === undefined || value === ''
    })
  }

  const transformFinalData = (data: FieldValues) => {
    const cloned = structuredClone(data)

    Object.keys(cloned).forEach((key) => {
      const value = cloned[key]

      if (!Array.isArray(value)) return
      if (value.length === 0) return
      if (typeof value[0] !== 'object') return

      cloned[key] = value.map((item) => {
        if (!item || typeof item !== 'object') return item

        const shouldRemove = Object.entries(item).every(([k, v]) => {
          if (k === 'id' || k === '_state' || k === 'record_status') return true

          if (
            typeof v === 'object' &&
            isEmptySubFormObject(
              (v as { _state?: string; [key: string]: unknown }) ?? {}
            )
          ) {
            return true
          }

          return (
            v === null ||
            v === undefined ||
            v === '' ||
            (Array.isArray(v) && v.length === 0)
          )
        })
        const { _state, ...rest } = item
        void _state

        const hasId = 'id' in item && item.id !== null && item.id !== undefined

        if (
          shouldRemove &&
          (_state === NAMESPACES.ADDED ||
            _state === NAMESPACES.ADDED.toLocaleLowerCase()) &&
          !hasId
        ) {
          return {
            ...rest,
            isOverriddenSubForm: true,
          }
        }

        return item
      })
    })

    return cloned
  }

  const fetchTableDataCallback = async (
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    const duplicatePayload = transformToDuplicateApiPayload(
      finalDataRef.current ?? {},
      taskMetaRef?.current?.entity_id?.toString() ?? '',
      listingLayout?.id?.toString() ?? '',
      listingLayout ?? undefined
    )

    const programId = caseData?.programs?.id ?? workflowDefinition?.program_id

    ;['programs', 'id'].forEach((field) => {
      if (!duplicatePayload.select.includes(field)) {
        duplicatePayload.select.push(field)
      }
    })

    if (!duplicatePayload.filters?.length) {
      duplicatePayload.filters = [{ criteria: [] }]
    }

    duplicatePayload.filters[0].criteria.push({
      field_name: 'id',
      operation: 'EQUALS',
      values: fromInteraction
        ? [caseId ?? '']
        : [new URLSearchParams(window.location.search).get('caseId') ?? ''],
    })

    if (duplicatePayload && duplicatePayload.related_entities) {
      duplicatePayload.related_entities.programs = {
        select: ['id'],
        filters: [
          {
            criteria: [
              {
                field_name: 'id',
                operation: 'EQUALS',
                values: [String(programId ?? '')],
              },
            ],
          },
        ],
      }
    }
    const res = await fetchDuplicateRecordsAPI(
      taskMetaRef?.current?.entity_id ?? 0,
      duplicatePayload,
      payload?.page as number,
      payload?.size as number
    )
    return res.data
  }

  const handleFormSubmit = async (
    data: FieldValues,
    originalFormData?: FieldValues
  ) => {
    let finalData: FieldValues = {
      ...data,
      record_status: draftRef?.current,
    }
    if (taskMetaRef?.current?.isCreateAssociate) {
      finalData = {
        id: taskMetaRef?.current?.record_id?.toString() ?? '',
      }
      finalData = getFinalData(finalData, data)
    } else {
      finalData = {
        ...data,
        record_status: draftRef?.current,
      }
    }
    if (!isEmpty(memberShipIdObjectRef?.current)) {
      finalData = {
        ...finalData,
        c_patient_product_copay_card_details_patient: [
          {
            ...finalData?.c_patient_product_copay_card_details_patient?.[0],
            ...memberShipIdObjectRef.current,
            ...(finalData?.c_patient_product_copay_card_details_patient?.[0]
              ?.id && {
              id: finalData?.c_patient_product_copay_card_details_patient?.[0]
                ?.id,
              _state: 'CHANGED',
            }),
          },
        ],
      }
    }
    finalDataRef.current = finalData

    const workflowEntity = {
      entityId:
        workflowDefinition?.definition?.processVariables?.entity_id?.toString() ??
        '',
      entityName:
        workflowDefinition?.definition?.processVariables?.entity_name ?? '',
      layoutId:
        workflowDefinition?.definition?.processVariables?.left_split?.edit_layout_id?.toString() ??
        '',
    }
    if (
      task?.identifier?.sub_ui_identifier ===
      WORKFLOW_ACTION_IDENTIFIER.SELECT_SINGLE_PAYER
    ) {
      const payer_details = task?.identifier?.payer_details
      if (payer_details?.field_name && payer_details?.key_name) {
        const count = originalFormData?.['subForm']?.[
          payer_details?.key_name
        ].filter(
          (item: CaseInsuranceCase) =>
            item?.[
              payer_details?.field_name as
                | 'create_appeal_case'
                | 'insurance_for_claim_support'
            ] === true
        ).length
        if (count !== 1) {
          dispatch(
            addToaster({
              message: 'Please select only one payer to proceed.',
              type: 'error',
              id: uuid(),
            })
          )
          return
        }
      }
    }

    dispatch(showLoader())

    try {
      if (!isTask && draftRef?.current !== RECORD_STATUS.DRAFT) {
        const duplicateRecords = await fetchTableDataCallback()
        if (duplicateRecords?.content?.length > 0) {
          setTotalResults(duplicateRecords?.totalElements ?? 0)
          const userConfirmed = await showDuplicateModal()

          if (!userConfirmed) {
            return
          }
        }
      }
      if (taskMetaRef?.current?.isCreate) {
        const response = await addEntityData(
          taskMetaRef?.current?.entity_name ?? '',
          Number(taskMetaRef?.current?.entity_id),
          Number(taskMetaRef?.current?.layout_id),
          finalData
        )
        if (response?.data) {
          setLayoutMode('add')
        }
      } else if (taskMetaRef?.current?.isCreateAssociate) {
        await handleCreateAssociate(workflowEntity, finalData)
      } else if (
        taskMetaRef?.current?.isEdit ||
        taskMetaRef?.current?.isEditAssociated
      ) {
        const transformedFinalData = transformFinalData(finalData)
        await handleEdit(transformedFinalData)
      }
      await handleAfterSubmit()
    } catch (err) {
      console.log(err)
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
      memberShipIdObjectRef.current = {}
      dispatch(triggerInteractionStatusEvent())
    }
  }

  const setCaseCompletionDateApi = async () => {
    try {
      await editEntityDataEmbeddedAPI(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(caseId),
        { case_completion_date: new Date().toISOString() },
        ['case_completion_date']
      )
    } catch (error) {
      console.error(error)
    }
  }

  const closeCurrentCaseAfterAttach = async () => {
    try {
      dispatch(showLoader())
      await caseCancelOrVoidApi(
        workflowInstance?.id?.toString(),
        STRINGS.CANCEL
      )
      const response = await getEntityDataByIdEmbedded(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(workflowDefinition?.global_variables?.entity_id),
        ['case_completion_date'],
        Number(caseId)
      )
      if (!response?.data?.case_completion_date) {
        await setCaseCompletionDateApi()
      }
    } catch (error) {
      console.error(error)
      dispatch(
        addToaster({
          message: STRINGS.SOMETHING_WENT_WRONG,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const onConfirmLink = async () => {
    const reviewer = `${authUser?.user?.first_name} ${authUser?.user?.last_name}`

    try {
      setIsLinkModalOpen(false)
      dispatch(showLoader())
      await attachCaseById({
        faxId: communicationId ?? '',
        caseId: attachCaseId ?? '',
        reason: NAMESPACES.NO_REASON,
        reviewer,
      })
      dispatch(
        addToaster({
          id: uniqueId(),
          message: CALL_INTERACTIONS.LINK_TOASTER_SUCCESS_MESSAGE,
          type: 'success',
        })
      )
    } catch (err) {
      console.error(err)
    } finally {
      await closeCurrentCaseAfterAttach()

      window.location.reload()
      openNewWindow(
        `/entity/32/workflow/review/${attachCaseId}?tabs=Correspondence`
      )
      dispatch(hideLoader())
    }
  }

  const previewFile = (url: string) => {
    setIsPreview(url)
  }

  const downloadFile = async (url: string, fileName: string) => {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(NAMESPACES.DOWNLOAD_ERROR)
    }

    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const aTag = document.createElement('a')
    aTag.href = blobUrl
    aTag.download = fileName
    document.body.appendChild(aTag)
    aTag.click()
    document.body.removeChild(aTag)
  }

  const downloadOrPreviewDocx = async (isPreview = false) => {
    try {
      let data
      if (!downloadFileData) {
        dispatch(showLoader())
        data = await previewAndDownload({
          entityId: Number(task?.case_id ?? ''),
          id: Number(task?.identifier?.document_id ?? ''),
        })
        setDownloadFileData(data?.data)
        dispatch(hideLoader())
      }
      const fileData = downloadFileData ?? data?.data
      const url = fileData?.url
      const name = fileData?.name ?? 'fileName'

      if (isPreview) {
        previewFile(url)
      } else {
        await downloadFile(url, name)
      }
    } catch (error) {
      dispatch(hideLoader())
      logErrorMessage('download and preview', error)
    }
  }

  const handleModalConfirm = async () => {
    if (confirmationModalObject.type === MODAL_TYPES.CANCEL) {
      if (!workflowDefinition?.global_variables?.multiIntake)
        updateStatusToProcessing && updateStatusToProcessing()
      navigate('../')
    } else if (confirmationModalObject.type === MODAL_TYPES.DRAFT) {
      handleSaveDraft()
    }
    setConfirmationModalObject({ type: '', state: false })
  }

  const injectScript = (url: string): HTMLScriptElement => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    document.body.appendChild(script)
    return script
  }

  const getUrlToInject = async (
    data: LayoutResponseType
  ): Promise<HTMLScriptElement | null> => {
    const path = data?.document?.attachment?.[0]?.path
    const name = data?.document?.attachment?.[0]?.name

    if (!path || !name) return null

    try {
      const url = await fetchDownloadUrlForSingleFIles(path, name)
      if (!url?.data) throw new Error('Invalid response')
      return injectScript(url.data?.url)
    } catch (error) {
      console.error(NAMESPACES.DOWNLOAD_ERROR, error)
      return null
    }
  }

  const callToPaySignTaskCreated = () => {
    const paySignTaskCreated = taskList?.some(
      (each) => each?.identifier?.disable_get_member_id
    )
    return paySignTaskCreated
  }
  const showDownload = () =>
    actionButtons.download ? (
      <SvgDownload
        className="cursor-pointer"
        onClick={() => downloadOrPreviewDocx()}
      />
    ) : null

  const showPreviewIcon = () =>
    actionButtons?.preview ? (
      <SvgView
        className="cursor-pointer"
        onClick={() => downloadOrPreviewDocx(true)}
      />
    ) : null

  const showSave = () =>
    !isReadOnlyUser() ? (
      actionButtons?.save ? (
        <CustomButton
          isFilled
          onClick={handleSaveButton}
          tabIndex={tabIndexOffset}
          disabled={task?.state !== WORKFLOW_STATUS.OPEN || isDisabled}
        >
          {task?.resource_id ||
          task?.state !== MODE_STATUS.COMPLETED.toUpperCase()
            ? NAMESPACES.UPDATE_BUTTON
            : NAMESPACES.SAVE_BUTTON}
        </CustomButton>
      ) : null
    ) : null

  const showGetMemberId = () =>
    !isReadOnlyUser() ? (
      actionButtons?.get_member_id ? (
        <div>
          <CustomButton
            isFilled={false}
            onClick={handleGetMemberIdButton}
            tabIndex={tabIndexOffset}
            className=""
            disabled={
              disableGetMemberIdButton ||
              task?.state === MODE_STATUS.COMPLETED.toUpperCase() ||
              callToPaySignTaskCreated()
            }
          >
            {NAMESPACES.GET_MEMBER_ID_AND_SAVE}
          </CustomButton>
        </div>
      ) : null
    ) : null

  const isUpdateButtonVisible = () => {
    const hasServicePermission = permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
    const hasIdentifierKey = task?.identifier?.task_permission
    if (hasIdentifierKey) {
      const hasTaskEditPermission =
        programPermissions[
          caseData?.programs?.id ?? workflowDefinition?.program_id ?? ''
        ]?.[hasIdentifierKey]?.Manage === true
      return hasTaskEditPermission
    } else {
      return hasServicePermission
    }
  }

  useEffect(() => {
    if (layout) {
      let scriptElement: HTMLScriptElement | null = null
      const handleScriptInjection = async () => {
        scriptElement = await getUrlToInject(layout)
      }
      handleScriptInjection()
      return () => {
        if (scriptElement?.parentNode) {
          scriptElement.parentNode.removeChild(scriptElement)
          console.log(NAMESPACES?.SCRIPT_CLEANUP)
        }
      }
    }
  }, [layout])

  useEffect(() => {
    const isOverviewLayout =
      task?.identifier?.layout_info?.layout_type ===
      LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE

    let save = task?.identifier?.action_buttons?.save
    const cancel = task?.identifier?.action_buttons?.cancel
    let edit = isOverviewLayout ? task?.identifier?.action_buttons?.edit : false
    let get_member_id = task?.identifier?.action_buttons?.get_member_id

    if (!task) return
    // fetchInfo()
    if (task?.state === MODE_STATUS?.PENDING?.toUpperCase() && isTask) {
      setLayoutMode('view')
      get_member_id = false
    } else if (
      task?.resource_id ||
      task?.state === MODE_STATUS.COMPLETED.toUpperCase()
    ) {
      setLayoutMode('view')
      save = false
      edit = task?.identifier?.action_buttons?.edit
      get_member_id = false
    } else if (task?.identifier?.create_new) {
      setLayoutMode('add')
      save = task?.identifier?.action_buttons?.save
      edit = false
      get_member_id = task?.identifier?.action_buttons?.get_member_id
    } else if (
      task?.identifier?.layout_info?.layout_type ===
      LAYOUT_TYPE_NAMESPACE?.VIEW_EDIT
    ) {
      setLayoutMode('edit')
      save = task?.identifier?.action_buttons?.save
      edit = false
      get_member_id = task?.identifier?.action_buttons?.get_member_id
    } else if (
      task.state === WORKFLOW_STATUS.OPEN.toUpperCase() &&
      isOverviewLayout
    ) {
      setLayoutMode('view')
    }
    if (
      task?.state === MODE_STATUS.COMPLETED.toUpperCase() &&
      task?.identifier?.ui_checks?.disable_edit_after_complete
    ) {
      setLayoutMode('view')
      save = false
      edit = false
      get_member_id = false
    }
    setActionButtons((prev) => ({
      ...prev,
      save,
      cancel,
      edit,
      get_member_id,
    }))
  }, [task])

  useEffect(() => {
    if (!isEmpty(refetchPane)) {
      fetchInfo()
    }
  }, [refetchPane])

  useEffect(() => {
    if (layoutMode) {
      fetchInfo()
    }
  }, [layoutMode, refetchCounter])

  useEffect(() => {
    if (layout) {
      setTabIndexMap(
        generateTabIndexMap(
          layout?.layout_data?.pages.map((page) => ({
            ...page,
            rows: page.rows.map((row) => ({
              ...row,
              label: row.label ?? '',
            })),
          })) as Page[],
          tabIndexOffset
        )
      )
    }
  }, [layout, tabIndexOffset])

  useEffect(() => {
    const loadListingLayout = async () => {
      const layout = await fetchListingLayout()
      setListingLayout(layout)
    }
    loadListingLayout()
  }, [])
  return (
    <div ref={containerRef}>
      {activeModal && (
        <Modal
          isOpen
          closeModal={() => setActiveModal(null)}
          showCloseButton={
            activeModal === WORKFLOW_MODAL_TYPES.UNRESOLVED_DEDUPE
          }
          width="min-w-[30vw] max-w-[70%]"
        >
          <div className="flex flex-col p-[0.87rem] w-[28.625rem] gap-5 mx-auto">
            <div className="flex flex-col gap-3">
              <div className="flex flex-col items-center gap-5">
                {MODAL_CONTENT[activeModal]()}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isTask ? null : (
        <div className="mb-2 flex items-center justify-end gap-3">
          {!fromInteraction &&
            (recordData?.case_key as string)?.startsWith(
              MAX_RTE_NAME_SPACE?.BV_ID_PREFIX
            ) &&
            selectedClientTenant?.id === TENANTS.TEVA && (
              <CheckEligibilityMaxRTE
                showDivider={false}
                formMethodsRef={formMethodsRef}
                from={CHECK_ELIGIBILITY_LOCATION.INTAKE}
              />
            )}
          {MEC_PORTAL_BTN && (
            <PatientEConsent
              workflowDef={workflowDefinition}
              caseID={recordId}
              formMethodsRef={formMethodsRef}
              from={CHECK_ELIGIBILITY_LOCATION.INTAKE}
            />
          )}
          {!isReadOnlyUser() ? (
            <>
              <CustomButton
                onClick={() => {
                  if (fromInteraction) {
                    onButtonClick && onButtonClick()
                  } else {
                    setConfirmationModalObject({ type: 'cancel', state: true })
                  }
                }}
                tabIndex={tabIndexOffset}
              >
                {NAMESPACES.CANCEL_BUTTON}
              </CustomButton>
              <CustomButton
                type="button"
                horizontalPaddingClasses="px-5"
                verticalPaddingClasses="py-3"
                className="flex items-center justify-center"
                onClick={() => {
                  isDraft.current = true
                  setConfirmationModalObject({
                    type: MODAL_TYPES.DRAFT,
                    state: true,
                  })
                }}
                tabIndex={tabIndexOffset}
              >
                {NAMESPACES.SAVE_AS_DRAFT}
              </CustomButton>

              <CustomButton
                type="button"
                isFilled
                onClick={() => {
                  isDraft.current = false
                  handleSaveButton()
                }}
                tabIndex={tabIndexOffset}
              >
                {NAMESPACES.SAVE_BUTTON}
              </CustomButton>
            </>
          ) : null}
        </div>
      )}
      <div className="border rounded border-accent-100 p-3 layout">
        <div
          className={`border-b pb-4 ${
            !isTask && !headerMessage ? 'hidden' : ''
          }`}
        >
          {isTask ? (
            <div className="flex items-center justify-between">
              {isMAXRTE && (
                <div className="ml-auto">
                  <CheckEligibilityMaxRTE
                    from={CHECK_ELIGIBILITY_LOCATION.CASE}
                    showTextButton={true}
                    showDivider={false}
                  />
                </div>
              )}
              {task?.identifier?.action_buttons?.epr_patient_request &&
                isEmpty(recordData?.pharmacy_id?.toString()) && (
                  <div className="ml-auto">
                    <EPRQueryButton
                      patientData={recordData ?? {}}
                      metaData={{
                        entity_id: task?.identifier?.entity_id ?? '',
                        layout_id:
                          task?.identifier?.layout_info?.layout_id ?? '',
                        entity_name: task?.identifier?.entity_name ?? '',
                      }}
                      disabled={
                        isLoader || task?.state !== WORKFLOW_STATUS?.OPEN
                      }
                    />
                  </div>
                )}

              {!isEmpty(isPreview) && (
                <Modal
                  isOpen={!!isPreview}
                  closeModal={() => setIsPreview(null)}
                  showCloseButton={true}
                >
                  {' '}
                  <div
                    className={`border border-accent-200 w-full document-editor__editable-container-view mt-2 bg-white overflow-clip`}
                  >
                    <embed
                      src={isPreview ?? ''}
                      width="1055rem"
                      height="1000rem"
                      className="max-w-full max-h-[80vh] object-contain"
                    />
                  </div>
                </Modal>
              )}
              <span></span>
              <div className="flex items-center gap-3">
                {showDownload()}
                {showPreviewIcon()}
                {/* {ActionButtons.cancel ? null : null} */}
                {showGetMemberId()}
                {isUpdateButtonVisible() ? showSave() : null}
                {!isReadOnlyUser() && isUpdateButtonVisible() ? (
                  actionButtons?.edit &&
                  !(
                    (workflowDefinition?.name?.includes('Benefit') &&
                      task?.name === 'Data Entry') ||
                    task?.state === 'CANCELLED'
                  ) ? (
                    <CustomButton
                      isFilled
                      disabled={
                        task?.state !== WORKFLOW_STATUS.OPEN || isDisabled
                      }
                      onClick={() => {
                        setLayoutMode('edit')
                        setActionButtons((prev) => ({
                          ...prev,
                          save: task?.identifier?.action_buttons?.save,
                          edit: false,
                          get_member_id:
                            task?.identifier?.action_buttons?.get_member_id,
                        }))
                      }}
                      tabIndex={tabIndexOffset}
                    >
                      {NAMESPACES.EDIT}
                    </CustomButton>
                  ) : null
                ) : null}
              </div>
            </div>
          ) : (
            <span className="font-bold text-base ">{headerMessage || ''}</span>
          )}
        </div>

        {isLoader ? (
          <SkeletonLoader />
        ) : (
          layoutMode && (
            <RenderNestedEntityLayoutTask
              associatedRecordId={associatedRecordId}
              draftSubmitFormButtonRef={draftSubmitFormButtonRef}
              fromInteraction={fromInteraction}
              handleFormSubmit={handleFormSubmit}
              layout={layout}
              layoutMode={
                !isUpdateButtonVisible() && isTask ? 'view' : layoutMode
              }
              onButtonClick={onButtonClick}
              recordData={recordData}
              submitFormButtonRef={submitFormButtonRef}
              task={task}
              tabIndexMap={tabIndexMap}
              tabIndexOffset={tabIndexOffset}
              setValue={setValue}
              register={register}
              isDisabled={isDisabled}
              handleInitForm={handleInitForm}
              recordId={recordId}
              isDraft={isDraft}
            />
          )
        )}
      </div>
      <ConfirmDialog
        message={
          confirmationModalObject.type === MODAL_TYPES.CANCEL
            ? NAMESPACES.CANCEL_CHANGE_MSG
            : NAMESPACES.SAVE_AS_DRAFT_CHANGE_MSG
        }
        onConfirm={handleModalConfirm}
        onCancel={() => {
          setConfirmationModalObject({ type: '', state: false })
        }}
        open={confirmationModalObject.state}
      />
      <CustomDialog
        isOpen={paysignErrorPopup.flag}
        onClose={() => setPaysignErrorPopup(paySignErrorInitialState)}
        width={'w-fit max-w-[98%]'}
      >
        <PaySignErrorPopup
          message={paysignErrorPopup.message}
          heading={paysignErrorPopup.heading}
          initialState={paySignErrorInitialState}
          setPaysignErrorPopup={setPaysignErrorPopup}
          ConfirmButtonText={MODAL_POPUP_ACTIONS.OK_UPPERCASE}
        />
      </CustomDialog>
      <DuplicatePopupModal
        isOpen={modalHandlers.isOpen ?? false}
        title={DUPLICATE_POPUP.DUPLICATES_FOUND}
        totalResults={totalResults}
        dataFetchCallback={(payload) => fetchTableDataCallback(payload)}
        entityId={Number(taskMetaRef?.current?.entity_id) ?? 0}
        entityName={taskMetaRef?.current?.entity_name ?? ''}
        layout={listingLayout}
        extraActions={duplicateActions.map((actionConfig) => ({
          ...actionConfig,
          onClick: (row: ListingTableRow) =>
            handleDuplicateTableActions(actionConfig.key, row),
        }))}
        onProceedAnyway={modalHandlers.onProceedAnyway}
        onCancel={() => {
          setModalHandlers({})
        }}
        communicationId={communicationId}
        updateStatusToProcessing={updateStatusToProcessing}
        faxDetails={faxDetails}
        intakeEntityName={intakeEntityName}
        fromInteraction={fromInteraction}
      />

      <ConfirmDialog
        open={isLinkModalOpen}
        onCancel={() => setIsLinkModalOpen(false)}
        message={CALL_INTERACTIONS.LINK_INTERACTION_MESSAGE}
        onConfirm={onConfirmLink}
        confirmButtonText={NAMESPACES.CONFIRM}
        cancelButtonText={NAMESPACES.CANCEL_BUTTON}
      />
    </div>
  )
}

const SubmitButton = ({
  draftSubmitFormButtonRef,
  submitFormButtonRef,
}: SubmitButtonEntityLayoutPropsType) => {
  return (
    <>
      <CustomButton
        className="hidden"
        isFilled
        ref={submitFormButtonRef}
        type="submit"
      >
        button
      </CustomButton>
      <CustomButton
        id={FORM_CONSTANTS?.SAVE_AS_DRAFT}
        className="hidden"
        isFilled
        ref={draftSubmitFormButtonRef}
        type="submit"
      >
        button
      </CustomButton>
    </>
  )
}

export const EntityLayoutCasePane: FC<EntityLayoutCasePanePropsTypes> = ({
  updateStatusToCompleted,
  updateStatusToProcessing,
  definition,
  instance,
  fromInteraction,
  onButtonClick,
  onDataFetch,
  tabIndexOffset,
  faxDetails,
  intakeEntityName,
}) => {
  const navigate = useNavigate()
  const { entityid, layoutid, id } = useParams()
  const caseId = new URLSearchParams(window.location.search).get('caseId')
  const workflowDefinitionSelector = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const workflowInstanceSelector = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const workflowDefinition = definition || workflowDefinitionSelector
  const workflowInstance = instance || workflowInstanceSelector
  const newInstance = useRef<WorkflowInstanceType | null>(null)

  const [refetch, setRefetch] = useState<{ isRefetch: boolean } | null>(null)
  const [render, setRender] = useState(false)

  const programServices = useAppSelector(
    (state) => state?.clientPermissions?.programServices
  )

  const dispatch = useAppDispatch()

  const taskRef = useRef<WorkflowInstanceTaskType | null>(null)
  const [taskResponseModal, setTaskResponseModal] =
    useState<TaskResponseModalStateType>({
      isOpen: false,
      workflow: null,
      task: workflowInstance?.tasks?.[0] || null,
    })
  const handleNavigation = (
    fromInteraction: boolean | undefined,
    url: string
  ) => {
    if (fromInteraction) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else {
      navigate(url)
    }
  }

  useEffect(() => {
    const fetchInitialAutomationStagingData = async () => {
      try {
        dispatch(showLoader())
        if (
          !caseId ||
          (!workflowDefinition?.global_variables?.multiIntake &&
            !workflowDefinition?.global_variables?.showDedup)
        )
          return
        const res = await getCaseDedupeStageData(+caseId)
        dispatch(updateAutomationStagedDetails(res?.data))
      } catch (err) {
        dispatch(updateAutomationStagedDetails(null))
        console.error(err)
      } finally {
        dispatch(hideLoader())
      }
    }
    fetchInitialAutomationStagingData()
  }, [
    workflowDefinition?.global_variables?.multiIntake,
    workflowDefinition?.global_variables?.showDedup,
  ])
  const completeTask = async () => {
    dispatch(showLoader())
    if (taskResponseModal?.workflow?.preRequisiteExecuted) {
      try {
        let meta_data = {}
        if (
          !!taskRef.current?.step_id &&
          !isEmpty(
            workflowDefinition?.definition?.steps?.[taskRef?.current?.step_id]
              ?.preRequisite
          )
        ) {
          meta_data = {
            entityId: taskRef?.current?.identifier?.entity_id,
            layoutId: taskRef?.current?.identifier?.layout_info?.layout_id,
          }
        }
        const programId = workflowDefinition?.program_id
        const serviceId = workflowDefinition?.service_id
        if (
          !isSuperAdmin() &&
          !programServices[programId ?? '']?.includes(serviceId ?? 0)
        ) {
          await editEntityDataEmbeddedAPI(
            workflowDefinition?.global_variables?.entity_name ?? '',
            workflowInstance?.case_id?.toString() ?? '',
            {
              entityName:
                workflowDefinition?.global_variables?.entity_name ?? '',
              users: {
                _state: 'REMOVED',
              },
            },
            ['users']
          )
        }
        const taskResponse = await completeTaskByTaskIdApi({
          taskId: taskRef?.current?.id ?? '',
          meta_data,
          forced: true,
        })
        if (taskResponse?.data) {
          handleTaskResponse(taskResponse?.data, true)
          if (taskResponse?.data?.checkerResult?.quickDenialDetails?.denied) {
            if (fromInteraction) handleModalClose()
            else {
              navigate(
                `/manage-queue/dynamic-queue/${entityid}/${layoutid}/${id}`
              )
            }
            dispatch(
              addToaster({
                message: STRINGS.QUICK_DENIAL_SUCCESS,
                type: 'success',
                id: uuid(),
              })
            )
          } else {
            const url = `/entity/${workflowDefinition?.definition?.processVariables?.entity_id}/workflow/review/${workflowInstance?.case_id}`
            handleNavigation(fromInteraction, url)
          }
        }
      } catch (err) {
        console.error(err)
      } finally {
        dispatch(hideLoader())
      }
    } else {
      dispatch(hideLoader())
      const url = `/entity/${workflowDefinition?.definition?.processVariables?.entity_id}/workflow/review/${workflowInstance?.case_id}`
      handleNavigation(fromInteraction, url)
    }
  }
  const handleProceedClick = async () => {
    await completeTask()
    updateStatusToCompleted?.()
  }

  const handleTaskResponse = (
    workflowData: WorkflowTaskCompleteResponseType,
    open = false
  ) => {
    setTaskResponseModal({
      isOpen: open,
      workflow: workflowData,
      task: workflowInstance?.tasks?.[0],
    })
  }

  const handleModalClose = () => {
    setTaskResponseModal({ isOpen: false, workflow: null })
    setRefetch((prev) => ({
      isRefetch: prev?.isRefetch ?? false,
    }))
    if (fromInteraction) {
      onButtonClick && onButtonClick()
    }
  }

  const fetchTasklist = async () => {
    dispatch(showLoader())
    try {
      const response = await getTaskListApi({
        search_criteria: [
          {
            search_key: 'CASE_ID',
            search_value: [workflowInstance?.case_id ?? ''],
            operator: 'EQUALS',
          },
        ],
      })
      if (response.data?.content?.length && workflowInstance?.tasks) {
        let task = response.data.content.find(
          (task: { identifier: { is_intake_layout: boolean } }) =>
            task.identifier?.is_intake_layout
        )
        if (
          workflowDefinition?.global_variables?.multiIntake &&
          workflowInstance.tasks.some(
            (task) => task.identifier?.is_intake_layout
          )
        ) {
          const workflowTask = workflowInstance.tasks.find(
            (task) => task.identifier?.is_intake_layout
          )
          task = response?.data?.content.find(
            (t: { id: string }) => t.id === workflowTask?.id
          )
        }
        const entity_id = workflowDefinition?.global_variables?.entity_id
        const entity_name = workflowDefinition?.global_variables?.entity_name
        const layout_id =
          workflowDefinition?.global_variables?.data_entry_layout?.layout_id
        if (!task && layout_id) {
          task = {
            identifier: {
              entity_id: entity_id,
              entity_name: entity_name,
              layout_info: {
                layout_id: layout_id,
                layout_type: NAMESPACES.EDIT_MODE,
              },
              task_id: FIELD_VALUE_CONSTANTS.INVALID,
            },
          }
        }
        if (task) {
          const newInst = cloneDeep(workflowInstance)
          if (newInst.tasks) {
            newInst.tasks.unshift({
              ...task,
              state: MODE_STATUS.PENDING.toUpperCase(),
            })
            newInstance.current = newInst
          }
        }
        setRender(true)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    if (workflowInstance) {
      if (workflowInstance.current_group || !workflowInstance.tasks?.length) {
        fetchTasklist()
      } else setRender(true)
    }
  }, [workflowInstance])

  if (!render) return null

  return (
    <React.Fragment>
      <EntityLayoutTask
        task={
          newInstance.current?.tasks?.[0] ||
          workflowInstance?.tasks?.[0] ||
          null
        }
        recordId={workflowInstance?.case_id ?? ''}
        isTask={false}
        selectCaseTaskRef={taskRef}
        handleTaskResponse={handleTaskResponse}
        refetchPane={refetch}
        handleRefetchPane={handleModalClose}
        updateStatusToCompleted={updateStatusToCompleted}
        updateStatusToProcessing={updateStatusToProcessing}
        definition={definition}
        instance={newInstance.current ?? instance}
        fromInteraction={fromInteraction}
        onButtonClick={onButtonClick}
        onDataFetch={onDataFetch}
        tabIndexOffset={tabIndexOffset}
        faxDetails={faxDetails}
        intakeEntityName={intakeEntityName}
      />

      {taskResponseModal?.isOpen && (
        <MissingInformationModal
          taskResponseModal={taskResponseModal}
          handleProceedClick={handleProceedClick}
          handleModalClose={handleModalClose}
          showButtons={true}
          definition={definition}
          instance={instance}
        />
      )}
    </React.Fragment>
  )
}

export default EntityLayoutCasePane

const RenderNestedEntityLayoutTask = ({
  layout,
  associatedRecordId,
  task,
  tabIndexMap,
  tabIndexOffset,
  fromInteraction,
  draftSubmitFormButtonRef,
  submitFormButtonRef,
  layoutMode,
  recordData,
  handleFormSubmit,
  onButtonClick,
  setValue,
  register,
  isDisabled,
  handleInitForm,
  recordId,
  isDraft,
}: RenderNestedEntityLayoutTaskPropsType) => {
  const subtotalkeys = [ENTITY_FIELDS.c_medical_expense_details_case.amount]

  const handleSubtotalChange = (_key: string, _subTotal: FieldValues) => {
    noop()
  }

  if (isEmpty(layout)) {
    return <div>No layout found</div>
  }
  const showTaskNoteAtTop = task?.identifier?.taskNoteValues?.isTaskNoteAtTop
  const taskNotesSuggestionBox = task?.identifier?.taskNoteValues
    ?.isTaskNoteSuggestionBox ? (
    <TaskNotesSuggestionBox
      task={task}
      mode={layoutMode}
      setValue={setValue}
      register={register}
      isShowSuggestion={task?.identifier?.taskNoteValues?.isTaskNoteAddButton}
      isDisabled={isDisabled}
    />
  ) : null
  const isTabLayout =
    layout?.type === LAYOUT_TYPE_NAMESPACE.TABS_TYPE &&
    associatedRecordId &&
    task?.identifier?.entity_id
  const isCustomLayout =
    task?.identifier?.ui_identifier ===
      WORKFLOW_UI_IDENTIFIER?.PAP_EXCEPTION_REVIEW_TASK ||
    task?.identifier?.ui_identifier ===
      WORKFLOW_UI_IDENTIFIER?.CUSTOM_LAYOUT_SCREEN ||
    CUSTOM_LAYOUTS_KEYS_LIST?.includes(layout?.type || '')

  if (isTabLayout) {
    return (
      <TabLayout
        layout={layout}
        isWorkflow={true}
        recordId={associatedRecordId.toString()}
        entityId={task.identifier?.entity_id ?? ''}
        tabIndexMap={tabIndexMap}
        tabIndexForTabs={tabIndexOffset}
      />
    )
  }

  if (isCustomLayout) {
    return (
      <>
        <HybridLayout
          layoutData={layout}
          isWorkflow={true}
          recordId={recordData?.id?.toString() ?? ''}
          handleFormSubmit={(data) => {
            handleFormSubmit(data)
          }}
          handleDraftSave={(data) => {
            handleFormSubmit(data)
            if (fromInteraction) {
              onButtonClick && onButtonClick()
            }
          }}
          formHeaders={
            <SubmitButton
              draftSubmitFormButtonRef={draftSubmitFormButtonRef}
              submitFormButtonRef={submitFormButtonRef}
            />
          }
          isDraft={isDraft}
          openAllAccordions={true}
          mode={layoutMode}
          task={task}
          // recordData={44660}
          // entityData={recordData}
        />
        {taskNotesSuggestionBox}
      </>
    )
  }

  return (
    <>
      {showTaskNoteAtTop && taskNotesSuggestionBox}
      <FormRenderer
        layout={layout.layout_data as LayoutData}
        handleFormDraftSubmit={(data, _, originalFormData) => {
          handleFormSubmit(data, originalFormData)
          if (fromInteraction) {
            onButtonClick && onButtonClick()
          }
        }}
        handleFormSubmit={(values, _, originalFormData) => {
          handleFormSubmit(values, originalFormData)
        }}
        heading={
          <SubmitButton
            draftSubmitFormButtonRef={draftSubmitFormButtonRef}
            submitFormButtonRef={submitFormButtonRef}
          />
        }
        // mode={isReadOnlyUser() ? 'view' : layoutMode}
        mode={layoutMode}
        data={recordData || null}
        fullLayout={layout as EntityLayout}
        tabIndexMap={tabIndexMap}
        addTaskId={
          task?.identifier?.add_task_id
            ? task.identifier.reference_task_id ?? task.id
            : undefined
        }
        addProductIdFilterForPaysign={
          task?.identifier?.action_buttons?.get_member_id
        }
        isTaskCompleted={
          !!(task?.state === MODE_STATUS?.COMPLETED?.toUpperCase())
        }
        handleInitForm={handleInitForm}
        task={task}
        subtotalkeys={
          task?.identifier?.sub_ui_identifier ===
          WORKFLOW_UI_IDENTIFIER?.MEDICAL_EXPENSE
            ? subtotalkeys
            : undefined
        }
        handleSubtotalChange={
          task?.identifier?.sub_ui_identifier ===
          WORKFLOW_UI_IDENTIFIER?.MEDICAL_EXPENSE
            ? handleSubtotalChange
            : undefined
        }
      />
      {task?.identifier?.custom_shipment_details_order_case ? (
        <ShipmentDetailsOrderCaseCustom
          task={task}
          mode={layoutMode}
          recordId={recordId}
        />
      ) : null}
      {!showTaskNoteAtTop && taskNotesSuggestionBox}
    </>
  )
}
